<template>
    <div class="message-input" :class="{ fw_msg_input: multiMessageOptionEnabled }">
        <div v-if="multiMessageOptionEnabled" class="forward_msg_action">
            <div class="row align-items-center">
                <div class="col">
                    <span class="forward_s_cross mr-2" role="button" tabindex="0" aria-label="Clear selected messages"
                        @click="$emit('clear-selection')" @keydown.enter.prevent="$emit('clear-selection')"
                        @keydown.space.prevent="$emit('clear-selection')">
                        <i class="fa fa-close" aria-hidden="true" />
                    </span>

                    <span class="f_m_selected">
                        {{ selectedMessageCount }} selected
                    </span>
                </div>

                <div v-if="selectedMessageCount" class="col-auto ml-auto text-right">
                    <i class="fa fa-share" role="button" tabindex="0" aria-label="Forward selected messages"
                        @click="$emit('forward-selection')" @keydown.enter.prevent="$emit('forward-selection')"
                        @keydown.space.prevent="$emit('forward-selection')" />
                </div>
            </div>
        </div>

        <div class="wrap">
            <suggestion-user-list v-if="canShowSuggestionList" v-model="selectedSuggestedUser"
                v-click-outside="closeSuggestionList" :selectedGroupID="selectedRoomId" :messageContentDraftVAL="value"
                @select="handleSuggestionSelected" @close="closeSuggestionList" />

            <div class="message_insert_box">
                <textarea id="chat-message-reply-input" ref="messageInput" :value="value" autocomplete="off"
                    class="regular-input" :class="selectionType" placeholder="Type a message..."
                    @keydown="$emit('keydown', $event)" @input="handleInput" @paste="$emit('paste', $event)" />

                <emoji-picker @emoji="$emit('emoji', $event)">
                    <button slot="emoji-invoker" slot-scope="{ events: { click: clickEvent } }" type="button"
                        class="emoji-invoker" aria-label="Open emoji picker" @click.stop="clickEvent">
                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
                            class="h-6 w-6 fill-current text-grey" aria-hidden="true">
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path
                                d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z" />
                        </svg>
                    </button>

                    <div slot="emoji-picker" slot-scope="{ emojis, insert }" class="emoji-picker-main-div">
                        <div class="emoji-picker">
                            <div>
                                <div v-for="(emojiGroup, category) in emojis" :key="category"
                                    :class="category === 'Frequently used' ? 'd-block' : 'd-none'">
                                    <div class="emojis">
                                        <span v-for="(emoji, emojiName) in emojiGroup" :key="emojiName"
                                            :title="emojiName" role="button" tabindex="0"
                                            :aria-label="'Insert ' + emojiName" @click="insert(emoji)"
                                            @keydown.enter.prevent="insert(emoji)"
                                            @keydown.space.prevent="insert(emoji)">
                                            {{ emoji }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </emoji-picker>
            </div>

            <div v-click-outside="closeOptions" class="option_btn_wrp">
                <button id="chat-message-reply-submit" type="button" class="submit" :disabled="!hasMessage"
                    aria-label="Send message" @click="handleSend">
                    <svg width="18" height="18" viewBox="1496 193 57 54" xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true">
                        <g id="Group-9-Copy-3" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
                            transform="translate(1523.000000, 220.000000) rotate(-270.000000) translate(-1523.000000, -220.000000) translate(1499.000000, 193.000000)">
                            <path
                                d="M5.42994667,44.5306122 L16.5955554,44.5306122 L21.049938,20.423658 C21.6518463,17.1661523 26.3121212,17.1441362 26.9447801,20.3958097 L31.6405465,44.5306122 L42.5313185,44.5306122 L23.9806326,7.0871633 L5.42994667,44.5306122 Z M22.0420732,48.0757124 C21.779222,49.4982538 20.5386331,50.5306122 19.0920112,50.5306122 L1.59009899,50.5306122 C-1.20169244,50.5306122 -2.87079654,47.7697069 -1.64625638,45.2980459 L20.8461928,-0.101616237 C22.1967178,-2.8275701 25.7710778,-2.81438868 27.1150723,-0.101616237 L49.6075215,45.2980459 C50.8414042,47.7885641 49.1422456,50.5306122 46.3613062,50.5306122 L29.1679835,50.5306122 C27.7320366,50.5306122 26.4974445,49.5130766 26.2232033,48.1035608 L24.0760553,37.0678766 L22.0420732,48.0757124 Z"
                                fill="#ffffff" fill-rule="nonzero" />
                        </g>
                    </svg>
                </button>

                <div class="option_btn_icon_wrp">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 15" fill="#ffffff" width="24" height="15"
                        focusable="false" role="button" tabindex="0" aria-label="Message send options"
                        :class="{ actv_btn: messageFeatureStates }" @click="$emit('toggle-options')"
                        @keydown.enter.prevent="$emit('toggle-options')"
                        @keydown.space.prevent="$emit('toggle-options')">
                        <path
                            d="M14 12a2 2 0 11-2-2 2 2 0 012 2zM4 10a2 2 0 102 2 2 2 0 00-2-2zm16 0a2 2 0 102 2 2 2 0 00-2-2z" />
                    </svg>

                    <div v-if="messageFeatureStates" class="option_btn_content_wrp">
                        <ul>
                            <li>
                                <input id="press_enter" type="radio" name="type" value="press_enter"
                                    :checked="selectionType === 'press_enter'"
                                    @change="$emit('option-change', 'press_enter')">
                                <label for="press_enter" :class="{ active: selectionType === 'press_enter' }">
                                    <span class="option_content_heading">
                                        Press Enter to Send
                                    </span>
                                    <span class="option_content_normal_txt">
                                        Pressing Enter will send message
                                    </span>
                                </label>
                            </li>

                            <li>
                                <input id="click_send" type="radio" name="type" value="click_send"
                                    :checked="selectionType === 'click_send'"
                                    @change="$emit('option-change', 'click_send')">
                                <label for="click_send" :class="{ active: selectionType === 'click_send' }">
                                    <span class="option_content_heading">
                                        Click Send
                                    </span>
                                    <span class="option_content_normal_txt">
                                        Clicking Send will send message
                                    </span>
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EmojiPicker from 'vue-emoji-picker'

const SuggestionUserList = () => import(
    './SuggestionUserList.vue'
)

export default {
    name: 'ChatMessageComposer',

    components: {
        EmojiPicker,
        SuggestionUserList
    },

    props: {
        selectedRoomInfo: {
            type: Object,
            default: null
        },

        selectedRoomId: {
            type: [String, Number],
            default: ''
        },

        value: {
            type: String,
            default: ''
        },

        multiMessageOptionEnabled: {
            type: Boolean,
            default: false
        },

        selectedMessageCount: {
            type: Number,
            default: 0,
            validator(value) {
                return value >= 0
            }
        },

        suggestionListVisible: {
            type: Boolean,
            default: false
        },

        suggestionUserData: {
            type: Object,
            default() {
                return {
                    handle: ''
                }
            }
        },

        selectionType: {
            type: String,
            default: 'press_enter',
            validator(value) {
                return [
                    'press_enter',
                    'click_send'
                ].indexOf(value) !== -1
            }
        },

        messageFeatureStates: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        isGroupChat() {
            return Boolean(
                this.selectedRoomInfo &&
                this.selectedRoomInfo.is_group_chat
            )
        },

        hasSelectedRoomId() {
            return (
                this.selectedRoomId !== null &&
                typeof this.selectedRoomId !== 'undefined' &&
                this.selectedRoomId !== ''
            )
        },

        canShowSuggestionList() {
            return (
                this.isGroupChat &&
                this.hasSelectedRoomId &&
                this.suggestionListVisible
            )
        },

        hasMessage() {
            return Boolean(
                String(this.value || '').trim()
            )
        },

        selectedSuggestedUser: {
            get() {
                return this.suggestionUserData
            },

            set(selectedData) {
                this.$emit(
                    'update:suggestion-user-data',
                    selectedData
                )

                // Use selectedData directly instead of waiting
                // for the prop to update again.
                this.insertSelectedMention(
                    selectedData && selectedData.handle
                )
            }
        }
    },

    methods: {
        insertSelectedMention(handle) {
            if (!handle) {
                return
            }

            const normalizedHandle = String(handle)
                .trim()
                .replace(/^@+/, '')

            if (!normalizedHandle) {
                return
            }

            const currentMessage = String(this.value || '')
            const lastAtIndex = currentMessage.lastIndexOf('@')

            let updatedMessage

            if (lastAtIndex !== -1) {
                updatedMessage =
                    currentMessage.slice(0, lastAtIndex) +
                    '@' +
                    normalizedHandle +
                    ' '
            } else {
                const separator =
                    currentMessage &&
                        !/\s$/.test(currentMessage)
                        ? ' '
                        : ''

                updatedMessage =
                    currentMessage +
                    separator +
                    '@' +
                    normalizedHandle +
                    ' '
            }

            // Updates messageContentDraftValue through v-model
            this.$emit('input', updatedMessage)

            this.$nextTick(() => {
                const input = this.$refs.messageInput

                if (!input) {
                    return
                }

                input.focus()

                const cursorPosition = updatedMessage.length

                input.setSelectionRange(
                    cursorPosition,
                    cursorPosition
                )
            })
        },
        handleInput(event) {
            const value = event && event.target
                ? event.target.value
                : ''

            this.$emit('input', value)
            this.$emit('message-input', event)
        },

        handleSend() {
            if (!this.hasMessage) {
                return
            }

            this.$emit('send')
        },

        handleSuggestionSelected(user) {
            this.$emit('suggestion-select', user)
        },

        closeSuggestionList() {
            this.$emit('suggestion-close')
        },

        closeOptions() {
            if (this.messageFeatureStates) {
                this.$emit('close-options')
            }
        },

        focusInput() {
            this.$nextTick(() => {
                if (this.$refs.messageInput) {
                    this.$refs.messageInput.focus()
                }
            })
        },

        getInputElement() {
            return this.$refs.messageInput || null
        }
    }
}
</script>

<style lang="scss" scoped>
.message-input {
    position: absolute;
    right: 0;
    bottom: 10px;
    left: 0;
    width: calc(100% - 20px);
    margin: 0 auto;
    padding: 5px 30px;
    border: 2px solid rgba(255, 255, 255, 0.15);
    border-radius: 35px;
    box-shadow: 0 1px 8px -1px rgba(162, 169, 176, 0.6);

    &:hover,
    &:focus-within {
        border-color: #ffc107;
    }

    &.fw_msg_input {
        border: none !important;
        box-shadow: none !important;

        .wrap {
            display: none !important;
        }
    }

    .wrap {
        position: relative;
        // z-index: 100;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;

        input,
        textarea {
            float: left;
            width: 100%;
            height: 35px;
            padding: 5px 0;
            overflow: -moz-scrollbars-none;
            color: #fff;
            font-size: 14px;
            font-family: "proxima-nova", "Source Sans Pro", sans-serif;
            line-height: 1.3;
            background: none;
            border: none;
            outline: none !important;
            resize: none;
            -ms-overflow-style: none;

            &::-webkit-scrollbar {
                display: none;
            }
        }

        .option_btn_wrp button {
            width: auto;
            height: auto;
            margin: 0 0 3px;
            padding: 0;
            color: #fff;
            cursor: pointer;
            background: none;
            border: none;
            outline: none !important;

            &:hover {
                color: #000;
                background: none;

                path {
                    fill: #ffc107 !important;
                }
            }
        }
    }

    @media only screen and (max-width: 767px) {
        padding: 8px 20px;
    }
}

.option_btn_wrp {
    position: relative;
    float: right;
    width: max-content;
    height: auto;
    text-align: center;
    background: none;

    .option_btn_icon_wrp {
        line-height: 1;
        text-align: center;

        svg {
            cursor: pointer;
            outline: none;

            &.actv_btn path {
                fill: #ffc107;
            }
        }
    }

    .option_btn_content_wrp {
        position: absolute;
        right: 0;
        bottom: 25px;
        z-index: 1000;
        width: 245px;
        padding: 10px;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        text-align: left;
        background: rgba(28, 29, 31, 0.98);
        border: 1px solid rgba(255, 255, 255, 0.03);
        border-radius: 5px;
        backdrop-filter: blur(20px);

        ul {
            margin: 0;

            input[type="radio"] {
                display: none;
            }

            .option_content_heading {
                display: block;
                margin-bottom: 1px;
                color: #ffe9e9;
                font-weight: 500;
                font-size: 14px;
            }

            .option_content_normal_txt {
                color: #f3f3f3;
                font-size: 12px;
            }

            li {
                label {
                    position: relative;
                    margin-bottom: 12px;
                    padding-left: 28px;
                    letter-spacing: 0.3px;
                    cursor: pointer;

                    &::before {
                        position: absolute;
                        top: 4px;
                        left: 0;
                        width: 15px;
                        height: 15px;
                        cursor: pointer;
                        border: 2px solid #f3f3f3;
                        border-radius: 50%;
                        content: "";
                        transition-duration: 167ms;
                        transition-property: box-shadow;
                        transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
                    }

                    &:hover::before {
                        box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.5);
                    }

                    &.active::before {
                        background: #38b124;
                        border-color: #38b124;
                    }
                }

                &:last-child label {
                    margin-bottom: 0;
                }
            }
        }
    }
}

.forward_msg_action {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 99;
    height: 55px;
    padding: 0 24px;
    line-height: 45px;
    background: #111;
    border-radius: 60px;

    span {
        display: inline-block;
        vertical-align: middle;

        &.f_m_selected {
            color: #ffc107;
            font-size: 16px;
            line-height: 1;
        }
    }

    .fa {
        font-size: 24px;
        line-height: 1;
        vertical-align: middle;
        cursor: pointer;

        &.fa-close:hover {
            color: #ff4338;
        }

        &.fa-share:hover {
            color: #ffc107;
        }
    }
}

.message_insert_box {
    position: relative;
    width: calc(100% - 85px);

    .emoji-invoker {
        position: absolute;
        right: -45px;
        bottom: 12px;
        width: 26px;
        height: 26px;
        padding: 0;
        cursor: pointer;
        background: transparent;
        border: 0;
        border-radius: 50%;
        transition: all 0.2s;

        &:hover {
            transform: scale(1.1);

            svg {
                fill: #ffc107;
            }
        }

        >svg {
            width: 26px;
            height: 26px;
            fill: #545555;
        }
    }

    .emoji-picker {
        position: absolute;
        top: -52px;
        right: 0;
        z-index: 1;
        box-sizing: border-box;
        height: auto;
        padding: 10px 15px;
        overflow: auto;
        font-family: 'Montserrat', sans-serif;
        background: #1d2226;
        border: 1px solid #2b2b2b;
        border-radius: 50px;

        .emojis {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            &::after {
                flex: auto;
                content: "";
            }

            span {
                padding: 0 2px;
                font-size: 18px;
                cursor: pointer;
                border-radius: 2px;

                &:hover {
                    cursor: pointer;
                    background: rgba(5, 5, 5, 0.15);
                }

                @media only screen and (max-width: 768px) {
                    font-size: 16px;
                }
            }
        }
    }
}
</style>
